import React from "react";
import { Navigate } from "react-router";

import BillingNew from "../../views/pages/dashboard/client/BillingNew";
import MyBots from "../../views/pages/dashboard/client/Home";
import Home from "../../views/pages/dashboard/distributor/Home";
import Materials from "../../views/pages/dashboard/distributor/Materials";
import Payouts from "../../views/pages/dashboard/distributor/Payouts";
import Referral from "../../views/pages/dashboard/distributor/Referral";
import Referrals from "../../views/pages/dashboard/distributor/Referrals";
import ExchangeAccount from "../../views/pages/dashboard/shared/ExchangeAccount";
//    Strapi perms that should be modified
// bot-config.getUserGeneralStats
// user.findOne
// referral.find
// exchange-account.findOne (should be only from referrals, removed find-as-owner for now))
// trade.findByBot (also removed find-as-owner for now)
import type { RouteProps } from "../routeTypes";
import Redirect from "../utils/Redirect";

export default (props: RouteProps) => {
  const { t } = props;
  return [
    {
      name: t("routes.home", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "home",
      showOnNav: true,
      icon: "fas fa-home text-default",
      component: <Home />,
    },

    // Distributor routes
    {
      name: t("routes.referralsList", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR"],
      path: "users",
      showOnNav: true,
      icon: "fas fa-user-friends text-default",
      component: <Referrals />,
    },
    {
      name: t("routes.referralsList", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR"],
      path: "users",
      showOnNav: false,
      icon: "fas fa-user-friends text-default",
      subRoutes: [
        {
          name: t("routes.admin.user", { ns: "dashboard" }),
          path: ":userId",
          showOnNav: false,
          icon: "fas fa-user text-default",
          subRoutes: [
            {
              name: t("routes.admin.user", { ns: "dashboard" }),
              path: "",
              showOnNav: false,
              icon: "fas fa-user text-default",
              component: <Referral />,
            },
            {
              name: t("routes.admin.bot", { ns: "dashboard" }),
              path: "exchange-account/:exchangeAccountId",
              showOnNav: false,
              icon: "fas fa-robot text-default",
              component: <ExchangeAccount hidePrivateInfo />,
            },
          ],
        },
      ],
    },
    {
      name: t("routes.managePayments", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR"],
      path: "payouts",
      showOnNav: true,
      icon: "fas fa-credit-card text-default",
      component: <Payouts />,
    },

    {
      name: t("routes.marketingMaterial", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "marketing-material",
      showOnNav: true,
      icon: "fas fa-images",
      component: <Materials sheet="1543395873" />,
    },
    {
      name: t("routes.educationalMaterial", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "tutorials-material",
      showOnNav: true,
      icon: "fas fa-book-open",
      component: <Materials sheet="1645589146" />,
    },
    {
      name: t("routes.contact", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "contact",
      showOnNav: true,
      icon: "fas fa-phone-alt px-1",
      component: <Redirect to="https://cal.com/investhinks" />,
    },

    // Client routes
    {
      name: t("routes.exchangeAccount", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "/exchange-account",
      showOnNav: false,
      icon: "fas fa-robot text-default",
      component: <ExchangeAccount />,
    },
    {
      name: t("routes.exchangeAccount", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "/exchange-account/:exchangeAccountId",
      showOnNav: false,
      icon: "fas fa-robot text-default",
      component: <ExchangeAccount />,
    },
    {
      name: t("routes.personalAccount", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "my-bots",
      showOnNav: true,
      icon: "fas fa-chart-bar text-primary",
      subRoutes: [
        {
          name: t("routes.exchangeAccounts", { ns: "dashboard" }),
          accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
          path: "",
          showOnNav: true,
          icon: "fas fa-chart-bar text-default",
          component: <MyBots />,
        },
        {
          name: t("routes.managePayments", { ns: "dashboard" }),
          accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
          path: "manage-payments",
          showOnNav: true,
          icon: "fas fa-credit-card text-default",
          component: <BillingNew />,
        },
      ],
    },

    {
      name: t("routes.faqs", { ns: "dashboard" }),
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      path: "faqs",
      showOnNav: true,
      icon: "fas fa-info px-1",
      component: <Redirect to="https://investhinks.com/faqs" />,
    },

    // {
    //   name: t("routes.info", { ns: "dashboard" }),
    //   accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
    //   path: "info",
    //   showOnNav: true,
    //   icon: "fas fa-info px-1",
    //   component: <Info/>,
    //   subRoutes: [
    //     {
    //       name: t("routes.presentation", { ns: "dashboard" }),
    //       path: "?scrollTo=presentation",
    //       showOnNav: true
    //     },
    //     {
    //       name: t("routes.faqs", { ns: "dashboard" }),
    //       path: "?scrollTo=faqs",
    //       showOnNav: true
    //     },
    //     {
    //       name: t("routes.affiliationProgram", { ns: "dashboard" }),
    //       path: "?scrollTo=affiliation-program",
    //       showOnNav: true
    //     }
    //   ]
    // },

    // Redirects
    {
      path: "",
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      index: true,
      component: <Navigate to="/home" replace={true} />,
    },
    {
      path: "*",
      accessRoles: ["DISTRIBUTOR", "REQUEST_DISTRIBUTOR"],
      index: true,
      component: <Navigate to="/home" replace={true} />,
    },
  ];
};
